import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from '@mui/icons-material';
import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { memo, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
const links = [{ title: 'Отображаемые устройства', key: 'devices' }];
export const Z3KDashboardSettingsNavigation = memo(function Z3KDashboardSettingsNavigation() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const openSetting = useCallback((path, options) => navigate(path, options), [navigate]);
    const navigation_links = useMemo(() => links.map(({ title, key }) => {
        return (_jsx(ListItem, { sx: { p: 0, bgcolor: 'transparent' }, onClick: () => openSetting(key, { state: { title } }), divider: true, children: _jsxs(ListItemButton, { selected: pathname.includes(key), children: [_jsx(ListItemText, { primary: title }), isSmallUI() && _jsx(ChevronRight, {})] }) }, key));
    }), [links, pathname]);
    return _jsx(List, { sx: { bgcolor: 'background.paper', p: 0 }, children: navigation_links });
});
